import {
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
	EventEmitter,
	Input,
	OnInit,
	Output,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';


import { VirtualKeyboardService } from '../../../../../../../libraries/ib-libraries/internetbank-fields/src/lib/field-components/input-field/keyboard-toggle/virtual-keyboard.service';
import {
	BiometricsRegistrationClientExistsException,
	BiometricsRegistrationDataRefinementException,
	BiometricsRegistrationRejectException,
} from '../../../common/exceptions/exceptions';
import { ConstantsService, InternetBankSettings } from '../../../common/services/constants.service';
import { DeprecatedPopUpService } from '../../../ui/controls/pop-up/pop-up.service';
import { CustomFormGroup } from '../../../ui/custom-reactive-forms/custom-form-group';
import { AuthorizationService } from '../../authorization.service';
import { ResetPasswordComponent } from '../../login/reset-password/reset-password.component';

type BiometricsRegistrationExceptions = BiometricsRegistrationClientExistsException
	| BiometricsRegistrationDataRefinementException
	| BiometricsRegistrationRejectException;

interface TemplateData {
	titleText?: string;
	messageText?: string;
	actionButton?: {
		title: string;
		action: () => void;
	};
}

@Component({
	selector: 'app-biometrics-registration-error-pop-up',
	templateUrl: './biometrics-registration-error.pop-up.component.html',
	styleUrls: ['./biometrics-registration-error.pop-up.component.less'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class BiometricsRegistrationErrorPopUpComponent implements OnInit {

	@Input()
	public resetPasswordPopUpComponent: ResetPasswordComponent;

	@Input()
	public exception: BiometricsRegistrationExceptions;

	@Input()
	public title: string = '';

	@Output()
	public closeWindow: EventEmitter<boolean> = new EventEmitter();

	public readonly popUpId = 'biometrics-registration-error-pop-up-id';

	public templateData: TemplateData | undefined;

	public resetFormStep1: CustomFormGroup;
	public settings: InternetBankSettings = ConstantsService.SETTINGS;
	public resetActivated: boolean = false;

	constructor(
		private modalService: DeprecatedPopUpService,
		private authorizationService: AuthorizationService,
		private virtualKeyboardService: VirtualKeyboardService,
		private router: Router,
		private activatedRoute: ActivatedRoute,
		private changeDetectorRef: ChangeDetectorRef,
	) {
	}


	public openModal(id: string): void {
		this.virtualKeyboardService.lastFocusedField = undefined;
		this.modalService.open(id);
	}

	public closeModal(id: string): void {
		this.closeWindow.emit(false);
		this.modalService.close(id);
	}

	public ngOnInit(): void {

	}

	public showPopUp(): void {
		this.templateData = this.createTemplateData(this.exception);

		this.closeWindow.emit(true);

		this.openModal(this.popUpId);

		this.changeDetectorRef.markForCheck();
	}

	public close(): void {
		this.closeModal(this.popUpId);
	}

	private createTemplateData(exception: BiometricsRegistrationExceptions): TemplateData {

		switch (true) {
			case exception instanceof BiometricsRegistrationClientExistsException:
				return {
					titleText: 'Внимание!',
					messageText: 'Вы уже являетесь Клиентом. Войдите в приложение или восстановите доступ',
					actionButton: {
						title: 'Войти',
						action: () => {
							this.close();
							this.resetPasswordPopUpComponent.showPasswordResetForm();
						},
					},
				};

			case exception instanceof BiometricsRegistrationDataRefinementException:
				return {
					titleText: 'Внимание!',
					messageText: 'Обратитесь в офис банка для уточнения данных',
					actionButton: {
						title: 'Найти ближайший офис',
						action: () => {
							window.location.href = 'https://www.rsb.ru/about/branch/';
						},
					},
				};

			case exception instanceof BiometricsRegistrationRejectException:
				return {
					titleText: 'К сожалению, Вам отказано в выпуске карты.',
					messageText: `Для получения дополнительной информации позвоните по телефону ${this.settings.PHONES.MSK} или обратитесь в отделение Банка`,
					actionButton: undefined,
				};

			default:
				return {
					titleText: undefined,
					messageText: undefined,
					actionButton: undefined,
				};
		}
	}

}
